/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as SignupRouteImport } from "./routes/signup"
import { Route as ResetPasswordRouteImport } from "./routes/reset-password"
import { Route as PassesRouteImport } from "./routes/passes"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as ForgotPasswordRouteImport } from "./routes/forgot-password"
import { Route as ConfirmRouteImport } from "./routes/confirm"
import { Route as CalendarRouteImport } from "./routes/calendar"
import { Route as AppRouteImport } from "./routes/app"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as AppIndexRouteImport } from "./routes/app/index"
import { Route as CheckoutSuccessRouteImport } from "./routes/checkout.success"
import { Route as AppWalletRouteImport } from "./routes/app/wallet"
import { Route as AppVenueRouteImport } from "./routes/app/venue"
import { Route as AppTenantsRouteImport } from "./routes/app/tenants"
import { Route as AppProfileRouteImport } from "./routes/app/profile"

const SignupRoute = SignupRouteImport.update({
  id: "/signup",
  path: "/signup",
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => rootRouteImport,
} as any)
const PassesRoute = PassesRouteImport.update({
  id: "/passes",
  path: "/passes",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmRoute = ConfirmRouteImport.update({
  id: "/confirm",
  path: "/confirm",
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarRoute = CalendarRouteImport.update({
  id: "/calendar",
  path: "/calendar",
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: "/app",
  path: "/app",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRoute,
} as any)
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
  id: "/checkout/success",
  path: "/checkout/success",
  getParentRoute: () => rootRouteImport,
} as any)
const AppWalletRoute = AppWalletRouteImport.update({
  id: "/wallet",
  path: "/wallet",
  getParentRoute: () => AppRoute,
} as any)
const AppVenueRoute = AppVenueRouteImport.update({
  id: "/venue",
  path: "/venue",
  getParentRoute: () => AppRoute,
} as any)
const AppTenantsRoute = AppTenantsRouteImport.update({
  id: "/tenants",
  path: "/tenants",
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/app": typeof AppRouteWithChildren
  "/calendar": typeof CalendarRoute
  "/confirm": typeof ConfirmRoute
  "/forgot-password": typeof ForgotPasswordRoute
  "/login": typeof LoginRoute
  "/passes": typeof PassesRoute
  "/reset-password": typeof ResetPasswordRoute
  "/signup": typeof SignupRoute
  "/app/profile": typeof AppProfileRoute
  "/app/tenants": typeof AppTenantsRoute
  "/app/venue": typeof AppVenueRoute
  "/app/wallet": typeof AppWalletRoute
  "/checkout/success": typeof CheckoutSuccessRoute
  "/app/": typeof AppIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/calendar": typeof CalendarRoute
  "/confirm": typeof ConfirmRoute
  "/forgot-password": typeof ForgotPasswordRoute
  "/login": typeof LoginRoute
  "/passes": typeof PassesRoute
  "/reset-password": typeof ResetPasswordRoute
  "/signup": typeof SignupRoute
  "/app/profile": typeof AppProfileRoute
  "/app/tenants": typeof AppTenantsRoute
  "/app/venue": typeof AppVenueRoute
  "/app/wallet": typeof AppWalletRoute
  "/checkout/success": typeof CheckoutSuccessRoute
  "/app": typeof AppIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/app": typeof AppRouteWithChildren
  "/calendar": typeof CalendarRoute
  "/confirm": typeof ConfirmRoute
  "/forgot-password": typeof ForgotPasswordRoute
  "/login": typeof LoginRoute
  "/passes": typeof PassesRoute
  "/reset-password": typeof ResetPasswordRoute
  "/signup": typeof SignupRoute
  "/app/profile": typeof AppProfileRoute
  "/app/tenants": typeof AppTenantsRoute
  "/app/venue": typeof AppVenueRoute
  "/app/wallet": typeof AppWalletRoute
  "/checkout/success": typeof CheckoutSuccessRoute
  "/app/": typeof AppIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/app"
    | "/calendar"
    | "/confirm"
    | "/forgot-password"
    | "/login"
    | "/passes"
    | "/reset-password"
    | "/signup"
    | "/app/profile"
    | "/app/tenants"
    | "/app/venue"
    | "/app/wallet"
    | "/checkout/success"
    | "/app/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/calendar"
    | "/confirm"
    | "/forgot-password"
    | "/login"
    | "/passes"
    | "/reset-password"
    | "/signup"
    | "/app/profile"
    | "/app/tenants"
    | "/app/venue"
    | "/app/wallet"
    | "/checkout/success"
    | "/app"
  id:
    | "__root__"
    | "/"
    | "/app"
    | "/calendar"
    | "/confirm"
    | "/forgot-password"
    | "/login"
    | "/passes"
    | "/reset-password"
    | "/signup"
    | "/app/profile"
    | "/app/tenants"
    | "/app/venue"
    | "/app/wallet"
    | "/checkout/success"
    | "/app/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  CalendarRoute: typeof CalendarRoute
  ConfirmRoute: typeof ConfirmRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PassesRoute: typeof PassesRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  CheckoutSuccessRoute: typeof CheckoutSuccessRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/signup": {
      id: "/signup"
      path: "/signup"
      fullPath: "/signup"
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/reset-password": {
      id: "/reset-password"
      path: "/reset-password"
      fullPath: "/reset-password"
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/passes": {
      id: "/passes"
      path: "/passes"
      fullPath: "/passes"
      preLoaderRoute: typeof PassesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/forgot-password": {
      id: "/forgot-password"
      path: "/forgot-password"
      fullPath: "/forgot-password"
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/confirm": {
      id: "/confirm"
      path: "/confirm"
      fullPath: "/confirm"
      preLoaderRoute: typeof ConfirmRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/calendar": {
      id: "/calendar"
      path: "/calendar"
      fullPath: "/calendar"
      preLoaderRoute: typeof CalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/app": {
      id: "/app"
      path: "/app"
      fullPath: "/app"
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/app/": {
      id: "/app/"
      path: "/"
      fullPath: "/app/"
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/checkout/success": {
      id: "/checkout/success"
      path: "/checkout/success"
      fullPath: "/checkout/success"
      preLoaderRoute: typeof CheckoutSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/app/wallet": {
      id: "/app/wallet"
      path: "/wallet"
      fullPath: "/app/wallet"
      preLoaderRoute: typeof AppWalletRouteImport
      parentRoute: typeof AppRoute
    }
    "/app/venue": {
      id: "/app/venue"
      path: "/venue"
      fullPath: "/app/venue"
      preLoaderRoute: typeof AppVenueRouteImport
      parentRoute: typeof AppRoute
    }
    "/app/tenants": {
      id: "/app/tenants"
      path: "/tenants"
      fullPath: "/app/tenants"
      preLoaderRoute: typeof AppTenantsRouteImport
      parentRoute: typeof AppRoute
    }
    "/app/profile": {
      id: "/app/profile"
      path: "/profile"
      fullPath: "/app/profile"
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppProfileRoute: typeof AppProfileRoute
  AppTenantsRoute: typeof AppTenantsRoute
  AppVenueRoute: typeof AppVenueRoute
  AppWalletRoute: typeof AppWalletRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppProfileRoute: AppProfileRoute,
  AppTenantsRoute: AppTenantsRoute,
  AppVenueRoute: AppVenueRoute,
  AppWalletRoute: AppWalletRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  CalendarRoute: CalendarRoute,
  ConfirmRoute: ConfirmRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PassesRoute: PassesRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  CheckoutSuccessRoute: CheckoutSuccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
